import React, { useEffect, useRef, useState } from "react";
import "../../styles/components/CaseArticle.css";
import Modal from "../../components/Modal";
import ContactFormSimple from "../../components/ContactFormSimple";
import arrowCircle from "../../img/hero/arrow-circle-2.png";
import cloudsImage from "../../img/cases/case-clouds-3.webp";

/* тимчасові картинки для What We Built */
import builtPhone1 from "../../img/cases/futura-phone-1.webp";
import builtIcon1 from "../../img/cases/built-icon-9.png";
import builtPhone2 from "../../img/cases/futura-phone-2.webp";
import builtIcon2 from "../../img/cases/built-icon-13.png";
import builtPhone3 from "../../img/cases/futura-phone-3.webp";
import builtIcon3 from "../../img/cases/built-icon-14.png";
import builtPhone4 from "../../img/cases/futura-phone-3.webp";
import builtIcon4 from "../../img/cases/built-icon-15.png";


import stackIcon32 from "../../img/cases/stack-icon-32.png";
import stackIcon33 from "../../img/cases/stack-icon-33.png";
import stackIcon34 from "../../img/cases/stack-icon-34.png";
import stackIcon1 from "../../img/cases/stack-icon-1.png";
import stackIcon25 from "../../img/cases/stack-icon-25.png";
import stackIcon14 from "../../img/cases/stack-icon-14.png";


import IconPng from "../../components/IconPng";

import resultsBg1 from "../../img/cases/results-bg-1.png";
import resultsBg2 from "../../img/cases/results-bg-2.png";


const sections = [
  {
    id: "about",
    title: "About the Project",
    text: [
      "For Futurra Group we built a marketing intelligence platform that automates competitor analysis end-to-end. The system collects competitor ad creatives via Meta ads data, then deploys AI-powered browser agents to walk through entire competitor funnels — capturing screens, flows, offers, and messaging. Everything is analyzed and structured automatically, giving marketing teams a full competitive picture without manual research",
    ],
  },
  {
    id: "challenge",
    title: "The Challenge",
    text: [
      "Marketing teams needed to analyze competitors across multiple layers — ad creatives, landing pages, onboarding flows, paywalls, offer structures, messaging. Doing this manually meant hours of clicking through funnels, taking screenshots, organizing data in spreadsheets, and repeating the process for every competitor. The work was tedious, slow, and impossible to scale.",
    ],
  },
  {
    id: "goal",
    title: "The Goal",
    text: [
      "Turn competitor analysis from a manual multi-day process into an automated pipeline that delivers structured, actionable insights in minutes.",
    ],
  },
];

const builtCards = [
  {
    id: "built-1",
    variant: "tablet",
    title: "Automated Creative Collection",
    text:
      "Integration with third-party services to access Meta ads data — pulling competitor creatives, ad copy, and targeting signals automatically.",
    icon: builtIcon1,
    image: builtPhone1,
  },

  {
    id: "built-2",
    variant: "tablet",
    title: "Agentic Funnel Crawling",
    text:
      "AI-powered browser agents (built on browser-use + Playwright) that navigate competitor funnels like a real user — clicking through landing pages, onboarding flows, paywalls, and offers. The system captures full screenshots and extracts content at every step..",
    icon: builtIcon2,
    image: builtPhone2,
  },

  {
    id: "built-3",
    variant: "tablet",
    title: "AI-Powered Analysis",
    text:
      "Collected data is processed through LLM pipelines (GPT and Gemini) that break down competitor strategies: messaging patterns, offer structures, funnel architecture, creative approaches. Results are structured and ready for decision-making",
    icon: builtIcon3,
    image: builtPhone3,
  },

  {
    id: "built-4",
    variant: "tablet",
    title: "Continuous Monitoring",
    text:
      "The system runs on schedule, tracking changes in competitor creatives and funnels over time — so teams see not just a snapshot, but how competitors evolve their strategies.",
    icon: builtIcon4,
    image: builtPhone4,
  },

];

const techStack = [
  {
    title: "Docker",
    icon: stackIcon32,
  },
  {
    title: "Playwright",
    icon: stackIcon33,
  },
  {
    title: "browser-use",
    icon: stackIcon34,
  },
  {
    title: "LangChain",
    icon: stackIcon1,
  },
  {
    title: "GPT family",
    icon: stackIcon25,
  },
  {
    title: "Gemini family",
    icon: stackIcon14,
  },
];

const resultsCards = [
  {
    variant: "small",
    icons: ["Component16", "Component17"],
    text:
      "Competitor analysis reduced from days of manual work to minutes",
  },
  {
    variant: "soft",
    icons: ["Component18", "Component19"],
    text:
      "Full-funnel visibility: from ad creative to paywall in one automated pipeline",
    bg: resultsBg1,
  },
  {
    variant: "wide",
    icons: ["Database", "Component20"],
    text:
      "Structured, actionable outputs ready for marketing decision-making",
  },
  {
    variant: "tall",
    icons: ["Component21", "Component22"],
    text:
      "Continuous monitoring of competitor strategy changes",
    bg: resultsBg2,
  },
];

const beforeAfterCards = [
  {
    variant: "before",
    title: "Before",
    text:
      "Manual research across multiple tools, hours of screenshots and spreadsheets, analysis outdated by the time it's finished, impossible to scale across many competitors.",
  },
  {
    variant: "after",
    title: "After",
    text:
      "Automated pipeline that collects creatives, crawls funnels, and delivers structured analysis — continuously and at scale.",
  },
];

const navItems = [
  ["about", "About the Project"],
  ["challenge", "The Challenge"],
  ["goal", "The Goal"],
  ["built", "What We Built"],
  ["key", "Key Challenge"],
  ["stack", "Tech Stack"],
  ["results", "Results"],
  ["before", "Before / After"],
  ["unique", "What Makes It Unique"],
];



export default function CaseArticleFutura() {
  const [activeId, setActiveId] = useState("about");
  const [openModal, setOpenModal] = useState(false);
  const isManualScrolling = useRef(false);
  const scrollTimer = useRef(null);

  useEffect(() => {
    const elements = navItems
      .map(([id]) => document.getElementById(id))
      .filter(Boolean);

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries.filter((entry) => entry.isIntersecting);

        if (visibleEntries.length > 0) {
          if (isManualScrolling.current) return;
          const closest = visibleEntries.sort(
            (a, b) => a.boundingClientRect.top - b.boundingClientRect.top
          )[0];



          setActiveId(closest.target.id);
        }
      },
      {
        root: null,
        rootMargin: "-25% 0px -60% 0px",
        threshold: 0,
      }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const items = document.querySelectorAll(".case-reveal-right");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -80px 0px",
      }
    );

    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  const handleNavClick = (e, id) => {
    e.preventDefault();

    isManualScrolling.current = true;
    setActiveId(id);

    const section = document.getElementById(id);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    clearTimeout(scrollTimer.current);

    scrollTimer.current = setTimeout(() => {
      isManualScrolling.current = false;
    }, 900);
  };

  return (
    <section className="case-article">
      <aside className="case-article__sidebar">
        <div className="case-article__toc">
          <h3>Contents</h3>

          <nav>
            {navItems.map(([id, label], index) => (
              <a
                key={id}
                href={`#${id}`}
                onClick={(e) => handleNavClick(e, id)}
                className={
                  activeId === id
                    ? "case-article__toc-link active"
                    : "case-article__toc-link"
                }
              >
                <span className="case-article__toc-line" />
                <span className="case-article__toc-number">{index + 1}</span>
                <span className="case-article__toc-label">{label}</span>
              </a>
            ))}
          </nav>
        </div>

        <div className="case-article__cta">
          <h3>
            Ready to make your product
            <br />
            personal? Let’s talk!
          </h3>

          <button
            type="button"
            className="case-article__cta-btn"
            onClick={() => setOpenModal(true)}
          >
            <span>Contact Us</span>
            <img src={arrowCircle} alt="" aria-hidden="true" />
          </button>

          <img
            className="case-article__cta-clouds"
            src={cloudsImage}
            alt=""
            aria-hidden="true"
          />
        </div>
      </aside>

      <div className="case-article__content">
        {sections.map((section) => (
          <section
            key={section.id}
            id={section.id}
            className="case-article__section case-reveal-right"
          >
            <h2>{section.title}</h2>

            {section.text.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </section>
        ))}

        <section id="built" className="case-article__section">
          <h2>What We Built</h2>

          <div className="case-built-list">
            {builtCards.map((card) => (
              <article
                className={`case-built-card case-built-card--${card.variant} case-reveal-right`}
                key={card.id}
              >
                <img
                  className="case-built-card__icon"
                  src={card.icon}
                  alt=""
                  aria-hidden="true"
                />

                <div className="case-built-card__text">
                  <h3>{card.title}</h3>
                  <p>{card.text}</p>
                </div>

                <img
                  className="case-built-card__image"
                  src={card.image}
                  alt=""
                />
              </article>
            ))}
          </div>
        </section>
        <section id="key" className="case-article__section case-reveal-right">
          <h2>Key Challenge</h2>

          <p>
            Building reliable agentic browsing at scale. Real-world competitor funnels are messy — dynamic content,
            pop-ups, geo-restrictions, A/B tests, anti-bot protections. The browser agents needed to handle all of
            this reliably and extract meaningful data, not just raw HTML. The combination of browser-use for navigation
            with LLM-based content analysis solved this — agents browse like humans and understand what they're seeing.
          </p>

        </section>
        <section id="stack" className="case-article__section case-reveal-right">
          <div className="case-stack">

            <h2 className="case-stack__title">Tech Stack</h2>

            <div className="case-stack__grid">
              {techStack.map((item) => (
                <div
                  key={item.title}
                  className={`case-stack__card ${item.size || ""}`}
                >
                  <img
                    src={item.icon}
                    alt=""
                    className={item.iconSize || ""}
                  />
                  <span>{item.title}</span>
                </div>
              ))}
            </div>

          </div>
        </section>

        <section id="results" className="case-article__section case-reveal-right">
          <h2>Results</h2>

          <div className="case-results">
            {resultsCards.map((card, index) => (
              <article
                key={index}
                className={`case-results__card case-results__card--${card.variant}`}
              >
                {card.bg && (
                  <img
                    className="case-results__bg"
                    src={card.bg}
                    alt=""
                    aria-hidden="true"
                  />
                )}

                <div className="case-results__icons">
                  {card.icons.map((icon) => (
                    <span className="case-results__icon" key={icon}>
                      <IconPng name={icon} size={28} />
                    </span>
                  ))}
                </div>

                {card.title && <h3>{card.title}</h3>}
                {card.text && <p>{card.text}</p>}
              </article>
            ))}
          </div>
        </section>

        <section id="before" className="case-article__section case-reveal-right">
          <div className="case-before-after">
            {beforeAfterCards.map((card) => (
              <article
                key={card.variant}
                className={`case-before-after__card case-before-after__card--${card.variant}`}
              >
                <h2>{card.title}</h2>
                <p>{card.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section id="unique" className="case-article__section case-reveal-right">
          <h2>What Makes It Unique</h2>

          <p>
            Not just a dashboard that aggregates ad data — a system with AI agents that actually browse competitor products
            like a real user, capturing the full experience from ad click to paywall. The combination of automated data
            collection, agentic browsing, and LLM-powered analysis creates a competitive intelligence pipeline that no manual
            process or traditional tool can match in speed or depth.
          </p>
        </section>

      </div>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title="Start your project"
      >
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </section>
  );
}
